<template>
  <div>
      <div class="main-container h3">
           Thank you for your Application.  <span style="color:green; border-radius:20px;border:5px solid green; background:green" class="fas text-white fa-check"></span>

      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style  scoped>
    .main-container {
    border:2px solid blac;
    /* margin-left:3vw; */
    height: auto;
    width:auto;
    margin:0px 0vw;
    text-align: center
 }
</style>>

</style>